import { Link } from './link.model';
import { Price } from './price.model'

export class BookingOffice {
	uuid: string;
	name: string;
	activShipmentTypes: string[] = [];
	activPaymentTypes: string[] = [];
	defaultShipmentType: string;
	defaultPaymentType: string;
	shipmentFees: { [key: string]: Price } = {};
	shipmentTypeAvailabilityInHours: { [key: string]: string } = {};
	paymentTypeAvailabilityInHours: { [key: string]: string } = {};
	paymentTargetTexts: { [key: string]: string } = {};

	public _links: {
		self: Link
	}
}




// WEBPACK FOOTER //
// ./src/app/models/booking-office.model.ts